<template>
  <va-show-layout :title="title" disable-delete disable-edit disable-clone>
    <va-show :item="item">
      <v-row justify="center">
        <v-col sm="10">
          <v-card v-if="item">
            <v-card-text>
              <va-field source="state"><v-progress-circular v-if="pollingActive" color="primary" indeterminate /> {{ item.state }}</va-field>
              <va-field source="command_name"></va-field>
              <va-field source="created_at" type="date"></va-field>
              <va-field source="created_by" type="email"></va-field>
              <va-display-json-field :label="$t('integrations.fields.payload')" source="payload" />
              <va-display-json-field :label="$t('integrations.fields.result')" source="result" />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </va-show>
  </va-show-layout>
</template>

<script>
export default {
  props: ["title", "item"],
  created() {
    if (this.item.state === "running") {
      this.startPolling();
    }
  },
  destroyed() {
    this.stopPolling();
  },
  data() {
    return {
      pollingActive: false,
      pollingInterval: null
    };
  },
  methods: {
    startPolling() {
      this.pollingActive = true;
      this.pollingInterval = setInterval(
        function() {
          this.poll();
        }.bind(this),
        2000
      );
    },
    stopPolling() {
      clearInterval(this.pollingInterval);
      this.pollingActive = false;
    },
    async poll() {
      await this.$store.dispatch("api/refresh", this.$route.meta.resource);
      if (this.item.state !== "running") {
        this.stopPolling();
      }
    }
  }
};
</script>
